import stylePagination from "./Pagination.module.css";
import { RowsPerPageSelect } from "./rowPageSelect";
function Pagination({ limit, count, active, callback }) {
  const num_pages = Math.ceil(count / limit);
  const pages = [];
  for (let index = 1; index <= num_pages; index++) {
    if (index === active) {
      const button = (
        <button
          type="button"
          key={index}
          onClick={() => callback(index)}
          className={`${stylePagination["btn-pagination"]} 
            ${stylePagination["active"]} btn btn-outline-secondary border-0 active rounded-1`}
        >
          {index}
        </button>
      );
      pages.push(button);
    } else {
      const button = (
        <button
          type="button"
          key={index}
          onClick={() => callback(index)}
          className={`${stylePagination["btn-pagination"]} btn btn-outline-secondary border-0 rounded-1`}
        >
          {index}
        </button>
      );
      pages.push(button);
    }
  }

  return (
    <div
      className={`${stylePagination["btn-toolbar"]} btn-toolbar mt-4 justify-content-center mb-3`}
      role="toolbar"
      aria-label="Toolbar with button groups"
    >
      <div
        className={`${stylePagination["btn-group"]} btn-group rounded-0`}
        role="group"
        aria-label="First group"
      >
        <button
          type="button"
          onClick={() => {
            callback(active - 1);
          }}
          id="previous_button"
          disabled={active <= 1 ? true : false}
          className={`${stylePagination["btn-pagination"]} btn btn-outline-secondary border-0 rounded-1`}
        >
          <i className="fa-solid fa-angle-right"></i>
        </button>
        {pages}
        <button
          type="button"
          id="next_button"
          onClick={() => callback(active + 1)}
          disabled={active >= num_pages ? true : false}
          className={`${stylePagination["btn-pagination"]} btn btn-outline-secondary border-0 rounded-1`}
        >
          <i className="fa-solid fa-angle-left"></i>
        </button>
      </div>
    </div>
  );
}

export function PaginationTax({
  limit,
  count,
  active,
  callback,
  handleLimitChange,
  disableLimitChange,
  links,
  isClaimPagination,
}) {
  const num_pages = Math.ceil(count / limit);
  const pages = [];

  const createButton = (index) => (
    <button
      type="button"
      key={index}
      onClick={() => callback(index)}
      className={`${stylePagination["btn-pagination"]} btn btn-outline-secondary border-0 rounded-1 ${
        index === active ? stylePagination["active"] + " active" : ""
      }`}
    >
      {index}
    </button>
  );

  if (num_pages <= 8) {
    // Show all pages
    for (let index = 1; index <= num_pages; index++) {
      pages.push(createButton(index));
    }
  } else {
    // Always show first page if active is very low
    if (active <= 3) {
      for (let index = 1; index <= 5; index++) {
        pages.push(createButton(index));
      }
      pages.push(
        <span key="ellipsis" className="px-2">
          ...
        </span>,
      );
      pages.push(createButton(num_pages - 1));
      pages.push(createButton(num_pages));
    }
    // Middle range: show 2 before and 2 after active
    else if (active > 3 && active < num_pages - 2) {
      pages.push(createButton(1));
      pages.push(
        <span key="ellipsis-start" className="px-2">
          ...
        </span>,
      );
      for (let index = active - 2; index <= active + 2; index++) {
        pages.push(createButton(index));
      }
      pages.push(
        <span key="ellipsis-end" className="px-2">
          ...
        </span>,
      );
      pages.push(createButton(num_pages));
    }
    // Near the end
    else {
      pages.push(createButton(1));
      pages.push(createButton(2));
      pages.push(
        <span key="ellipsis" className="px-2">
          ...
        </span>,
      );
      for (let index = num_pages - 4; index <= num_pages; index++) {
        pages.push(createButton(index));
      }
    }
  }

  return (
    <div
      className={`${stylePagination["btn-toolbar"]} btn-toolbar mt-4 justify-content-center mb-3`}
      role="toolbar"
      aria-label="Toolbar with button groups"
    >
      <div
        className={`${stylePagination["btn-group"]} btn-group rounded-0`}
        role="group"
        aria-label="First group"
      >
        <button
          type="button"
          onClick={() => callback(active - 1)}
          disabled={!count || count <= limit || active <= 1}
          className={`${stylePagination["btn-pagination"]} btn btn-outline-secondary border-0 rounded-1`}
        >
          <i className="fa-solid fa-angle-right"></i>
        </button>

        {pages}

        <button
          type="button"
          onClick={() => callback(active + 1)}
          disabled={
            !count ||
            count <= limit ||
            active >= num_pages ||
            links?.next === null
          }
          className={`${stylePagination["btn-pagination"]} btn btn-outline-secondary border-0 rounded-1`}
        >
          <i className="fa-solid fa-angle-left"></i>
        </button>

        {!disableLimitChange && (
          <RowsPerPageSelect
            value={limit}
            pageSizeOptions={
              isClaimPagination
                ? [10, 50, 100, 300, 500]
                : [10, 20, 50, 100, 300, 500]
            }
            onChange={(e) => handleLimitChange(Number(e.target.value))}
          />
        )}
      </div>
    </div>
  );
}

export default Pagination;
